// extracted by extract-css-chunks-webpack-plugin
module.exports = {"spacing-1":"0.25rem","spacing-3":"1rem","container":"_2LPeZx"};